<template>
  <div
    class="user-item pa-1"
    style="position: relative"
    :style="user.is_leave_group || user.is_blocked ? 'background: gainsboro' : ''"
    :class="{
      'primary lighten-3 white--text': selected,
      'red lighten-3': $aston.astonpages.includes($store.state.livechat.pageid) && !user.adminreply,
      unreadmessage: !user.adminread
    }"
  >
    <!-- 'grey lighten-4': !user.is_24hr_available && $store.state.livechat.app == 'facebook', -->
    <!-- <div
      v-if="!user.is_24hr_available && $store.state.livechat.app == 'facebook'"
      style="position: absolute;right: 20px;top: 10px;z-index: 3"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            small
            class=" ma-0"
            fab
            color="grey"
            style="height: 20px; width: 20px"
            depressed
            v-on="on"
            >!</v-btn
          >
        </template>
        <span>{{ $t("Cannot send a message, the user's response is over 24 hours.") }}</span>
      </v-tooltip>
    </div> -->
    <v-list-tile avatar>
      <v-checkbox
        v-model="selectedUser"
        @click.native.prevent.stop.capture="toggleSelectUser"
        v-if="$store.state.livechat.show_select_user"
        class="mr-0"
        style="vertical-align: middle;"
        color="primary"
      ></v-checkbox>
      <v-list-tile-avatar>
        <template v-if="user.profile_pic || user.group_picture_url">
          <img
            class="profile"
            :src="user.source_type ? user.group_picture_url : user.profile_pic"
            alt
            @error="imgError(this)"
          />
        </template>
        <template v-else>
          <img class="profile" src="/static/img/assets/livechat/profile.png" alt />
        </template>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title style="max-width:280px" :class="{ unreadmessage: !user.adminread }">{{
          user.source_type
            ? user.group_name
            : `${
                user.nickname ? user.nickname : user.first_name || '' + ' ' + user.last_name || ''
              } `
        }}</v-list-tile-title>
        <v-list-tile-sub-title
          v-if="!user.is_blocked"
          class="caption grey--text text--lighten-1"
          :class="{ unreadmessage: !user.adminread }"
          :title="lastmessage(user.lastmessage || '')"
        >
          {{ lastmessage(user.lastmessage || '') | truncate(23) }}
        </v-list-tile-sub-title>
        <small v-if="user.is_blocked" class="caption text--lighten-1" style="color:red">
          {{ $t('This group has been blocked by admin.') }}
          <i
            class="fas fa-question-circle"
            v-tooltip.top="
              $t('The messages sent by the customer after this will not be displayed and stored.')
            "
          ></i>
        </small>
        <v-list-tile-sub-title
          v-if="!user.is_blocked"
          class="caption text--lighten-1"
          :class="{ unreadmessage: !user.adminread }"
          :key="timestamp"
        >
          {{ dayLeft(user.lastreply_time) }}
          <template
            v-if="
              user.temp_last_updated_by &&
                $store.state.SOCKET_GROUP_GT817.includes($store.state.livechat.pageid)
            "
          >
            ({{ lastmessage(adminName || '') | truncate(23) }})
          </template>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <!-- <v-list-tile-action></v-list-tile-action> -->
    </v-list-tile>
    <div v-if="selectedBot.theme == 'scgallrent'" class="text-xs-right">
      <v-chip v-if="user.status == 'Customer&Supplier'" small color="red" dark class="caption">{{
        user.status
      }}</v-chip>
      <v-chip v-else-if="user.status == 'Customer'" small color="blue" dark class="caption">{{
        user.status
      }}</v-chip>
      <v-chip v-else-if="user.status == 'Supplier'" small color="orange" dark class="caption">{{
        user.status
      }}</v-chip>
    </div>
    <div style="display: flex;">
      <ul class="tags mt-0">
        <template v-for="(usertag, index) in usertags">
          <li
            class="tag primary"
            :key="'usertag_' + index"
            v-if="index < 2"
            style="padding: 0px 10px; color:#ffffff; font-size: 11px;"
          >
            {{ transformTag(usertag) }}
          </li>
        </template>
      </ul>
      <v-menu open-on-hover offset-y v-if="usertags.length > 2">
        <template v-slot:activator="{ on }">
          <v-btn
            outline
            fab
            small
            color="grey"
            v-on="on"
            class="ma-1"
            style="width: 18px; height: 18px;"
          >
            <v-icon style="font-size: 11px;">fa fa-ellipsis-h</v-icon>
          </v-btn>
        </template>
        <v-list style="max-height: 300px;">
          <template v-for="(usertag, index) in usertags">
            <v-list-tile
              style="background-color: #fff;"
              :key="'usertag_' + index"
              v-if="index >= 2"
            >
              <v-list-tile-title style="font-size: 12px;">{{ transformTag(usertag) }}</v-list-tile-title>
            </v-list-tile>
          </template>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  props: ['value', 'selected'],
  data: function() {
    return {
      user: this.value,
      hasNewMessage: false,
      timestamp: dayjs().format('x'),
      refreshInterval: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    selectedUser() {
      return this.$store.state.livechat.selected_users.indexOf(this.user.userid) != -1
    },
    usertags: function() {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    adminName() {
      const vm = this
      if (vm.user.temp_last_updated_by) {
        if (/^\d+$/.test(vm.user.temp_last_updated_by)) {
          var result = vm.$store.state.facebook_users_name.find(
            el => el.id == vm.user.temp_last_updated_by
          )
          return result ? result.name : vm.user.temp_last_updated_by
        } else {
          return vm.user.temp_last_updated_by
        }
      } else return ''
    }
  },
  filters: {
    time: function(date) {
      if (typeof date === 'string') {
        date = dayjs(date)
      }
      return date.format('h:mm A')
    }
  },
  mounted: function() {
    const vm = this
    if (vm.user.temp_last_updated_by && /^\d+$/.test(vm.user.temp_last_updated_by))
      vm.getFbName(vm.user.temp_last_updated_by)

    vm.refreshInterval = setInterval(() => {
      vm.timestamp = dayjs().format('x')
    }, 1000)
  },
  destroyed() {
    const vm = this
    clearInterval(vm.refreshInterval)
  },
  methods: {
    async getFbName(userid) {
      var vm = this
      var fbusersname = vm.$store.state.facebook_users_name
      if (!fbusersname.some(el => el.id == userid))
        var result = await axios.get(
          `https://graph.facebook.com/${userid}?fields=name&access_token=${vm.selectedBot
            .page_access_token || vm.$store.state.facebook_info.facebook_access_token}`
        )
      if (result) {
        vm.$store.state.facebook_users_name.push(result.data)
      }
    },
    lastmessage(lastmessage) {
      try {
        const pattern = /{\"type\":\"audio\",.*\"contentProvider\":{\"type\":\"line\"}/
        if(pattern.test(lastmessage)) {
          return this.$t('User sent a voice message')
        } else {
          return JSON.parse(lastmessage)[0].text || ''
        }
      } catch (error) {
        return lastmessage
      }
    },
    toggleSelectUser() {
      let index = this.$store.state.livechat.selected_users.indexOf(this.user.userid)
      if (index != -1) {
        this.$store.state.livechat.selected_users.splice(index, 1)
      } else {
        this.$store.state.livechat.selected_users.push(this.user.userid)
      }
    },
    imgError: function(event, el) {
      this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    },
    dayLeft: function(replytime) {
      var lastreply = dayjs(replytime)
      var currentDate = dayjs()

      var time = ''
      if (currentDate.diff(lastreply, 'days') > 0) {
        time = lastreply.format('DD MMM YYYY')
      } else if (currentDate.diff(lastreply, 'hours') > 0) {
        time = currentDate.diff(lastreply, 'hours')
        time += ' ' + this.$t('Hours')
      } else if (currentDate.diff(lastreply, 'minutes') > 0) {
        time = currentDate.diff(lastreply, 'minutes')
        time += ' ' + this.$t('Minutes')
      } else if (currentDate.diff(lastreply, 'seconds') > 0) {
        time = currentDate.diff(lastreply, 'seconds')
        time += ' ' + this.$t('Seconds')
      }
      return time
    },
    transformTag(tag) {
      let tags = tag
      if (tags) {
        const systemTags = {
          '{{slip_completed_1}}': 'ตรวจสลิป 1 ครั้ง',
          '{{slip_completed_more_than_1}}': 'ตรวจสลิปมากกว่า 1 ครั้ง',
        }
    
        for (const [key, value] of Object.entries(systemTags)) {
          tags = tags.replaceAll(key, value)
        }
      }
      return tags
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.user = this.value
      if (newVal.lastreply_time != oldVal.lastreply_time) {
        if (this.selected != true) {
          this.hasNewMessage = true
        }
      }
    },
    selected: function(newVal, oldVal) {}
  }
}
</script>

<style lang="scss" scoped>
.user-item {
  .active {
  }
}
.unreadmessage {
  color: black !important;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-user-item.vue